import styled, { css } from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import type { IDropdownButtonProps } from "@similarweb/ui-components";
import { DropdownItem } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

// A combobox trigger's wrap is width:100% behind a display:contents boundary, so in a flex row it
// becomes a greedy item that overruns its own button. Pin it to hug the button's width.
export const pinDropdownTriggerToWidthCss = css`
    & :has(> .DropdownButton) {
        flex: none;
        width: auto;
    }
`;

export const StyledOperatorFieldRow = styled(Flex)`
    align-items: center;
    gap: 8px;
    ${pinDropdownTriggerToWidthCss}
`;

export const singleSelectDDContentStyles = css`
    padding: 8px !important;
`;

export const StyledSingleSelectDDItemText = styled.span`
    ${mixins.setFontVariant("input2", colorsPalettes.carbon["500"])};
`;

export const StyledSingleSelectDDItem = styled(DropdownItem)`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;
    padding-right: 16px;
`;

export const StyledDropdownParent = styled.div`
    position: relative;
    min-width: 0;

    & .Popup-content {
        ${singleSelectDDContentStyles};
    }
`;

type StyledBaseDropdownButtonWrapProps = IDropdownButtonProps & {
    buttonTextColor: string;
    disabled?: boolean;
};

const StyledBaseDropdownButtonWrap = styled.div.attrs<
    Partial<StyledBaseDropdownButtonWrapProps>,
    StyledBaseDropdownButtonWrapProps
>(({ buttonTextColor = colorsPalettes.carbon[200], disabled = false }) => ({
    buttonTextColor,
    disabled,
}))`
    width: 100%;

    & .DropdownButton {
        background-color: ${colorsPalettes.carbon["0"]};
        border-color: ${colorsPalettes.midnight["50"]};
        box-sizing: border-box;
        color: ${(props) => props.buttonTextColor};
        height: 40px;

        ${({ disabled }) =>
            disabled &&
            css`
                background-color: ${colorsPalettes.bluegrey[200]};
            `}

        .DropdownButton--triangle {
            color: ${({ disabled }) => (disabled ? colorsPalettes.midnight[100] : colorsPalettes.carbon[400])};
        }
    }

    & .DropdownButton:active {
        background-color: ${colorsPalettes.carbon[0]};
        color: ${(props) => props.buttonTextColor};

        .DropdownButton--triangle {
            color: ${colorsPalettes.carbon[400]};
        }
    }
`;

export const StyledHighlightedDropdownButtonWrap = styled(StyledBaseDropdownButtonWrap)`
    & .DropdownButton {
        ${({ hasValue }) =>
            !hasValue &&
            css`
                color: ${colorsPalettes.carbon[200]};
            `}

        ${({ isOpen, buttonTextColor }) =>
            isOpen &&
            css`
                color: ${buttonTextColor};
                border-color: ${colorsPalettes.blue[400]};
            `}
    }

    & .DropdownButton:active {
        border-color: ${colorsPalettes.blue[400]};
    }
`;
